import { render, staticRenderFns } from "./uniapp_version_list.vue?vue&type=template&id=6ad632d1"
import script from "./uniapp_version_list.vue?vue&type=script&lang=js"
export * from "./uniapp_version_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports